import React from "react";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>Interaktív zoom megbeszélés információk</h1>
		<p>Tisztelt Kollégák, Kedves Felhasználók!</p>
		<p>
			Ezúton is köszönjük, hogy kitöltötték a kérdőívet, és ezzel is
			segítik a rendszer fejlődését.
		</p>
		<p>
			Az interaktív zoom megbeszélés az alábbi dátumokon és minden
			alkalommal ugyanazon a linken érhető el:
			<br />
			2024.12.12. 14:00
			<br />
			2024.12.13. 9:00
			<br />
			2024.12.17. 10:00
		</p>
		<p>
			Itt kapcsolódhat a megbeszéléshez:
			<br />
			<a
				href="https://semmelweis.zoom.us/j/94976433473?pwd=bRUNBtf1KSDTz1Xjy7KSessdwxXbDH.1"
				target="_blank"
				rel="noopener noreferrer"
			>
				https://semmelweis.zoom.us/j/94976433473?pwd=bRUNBtf1KSDTz1Xjy7KSessdwxXbDH.1
			</a>
			<br />
			Meeting ID: 949 7643 3473
			<br />
			Passcode: 817468
		</p>
		<p>Részvételükre feltétlenül számítunk!</p>
		<p>
			Üdvözlettel, <br />
			Budapesti Vese és Vese-hasnyálmirigy transzplantációs várólista
			bizottság és a fejlesztők
		</p>
	</section>
);
